<template>
	<div class="searchCon">
		<div class="content">
			<div class="topHead">
				<div class="searchbox">
					<div class="city" @click="cityShow=true">{{city}}</div>
					<input class="input" v-model="position_name" type="text" placeholder="搜索职位"/>
					<div class="btnsty" @click="search()">搜索</div>
				</div>
				<div class="screenbox">
					<div class="tagbox">
						招聘类型<span v-if="type!==''">（1）</span>
						<div class="relativebox">
							<div class="screenlist" style="height: auto;width: 150px;">
								<div class="list" :class="{'select':type===''}" @click="restScreen('type','String')">
									不限 <i v-if="type===''" class="el-icon-check icon"></i>
								</div>
								<div class="list" :class="{'select':type==='0'}" @click="pickType('0')">
									社招 <i v-if="type==='0'" class="el-icon-check icon"></i>
								</div>
								<div class="list" :class="{'select':type==='1'}" @click="pickType('1')">
									实习生招聘 <i v-if="type==='1'" class="el-icon-check icon"></i>
								</div>
								<div class="list" :class="{'select':type==='2'}" @click="pickType('2')">
									兼职招聘 <i v-if="type==='2'" class="el-icon-check icon"></i>
								</div>
							</div>
						</div>
					</div>
					<!-- 职位类型 -->
					<div class="tagbox">
						职位类型<span v-if="position_type_ids.length>0">（{{position_type_ids.length}}）</span>
						<div class="relativebox" @mouseleave="jobIndex=-1">
							<div class="screenlist">
								<div class="list" :class="{'select':position_type_ids.length==0}" @click="restScreen('position_type_ids','array')">不限</div>
								<div 
									class="list" 
									:class="{'select':calcChild(item.child)>0}"
									v-for="(item,index) in positionTypeList" 
									:key="index" 
									@mouseenter="jobIndex=index">
									{{item.type_name}} 
									<span class="icon" style="font-size: 14px;" v-if="calcChild(item.child)>0">{{calcChild(item.child)}}</span>
									<!-- <i v-if="calcChild(item.child)" class="el-icon-caret-right icon"></i> -->
								</div>
							</div>
							<div class="listChild" v-show="jobIndex!=-1">
								<template v-if="positionTypeList.length>0&&jobIndex!=-1">
									<div class="chiildTitle">{{positionTypeList[jobIndex].type_name}}</div>
									<div class="childContent">
										<div class="text" v-for="jobtype in positionTypeList[jobIndex].child" :key="jobtype.id">
											<span :class="{'select':position_type_ids.includes(jobtype.id)}" @click="chooseJobType(jobtype.id)">{{jobtype.type_name}}</span>
										</div>
									</div>
								</template>
							</div>
						</div>
					</div>
					<!-- 期望薪资 -->
					<div class="tagbox">
						期望薪资<span v-if="salary_min||salary_max">（1）</span>
						<div class="relativebox">
							<div class="screenlist" style="height: auto;width: 150px;">
								<div 
									class="list" 
									:class="{'select':salary_min==item.min&&salary_max==item.max}"
									v-for="(item,index) in salaryList" 
									:key="index" 
									@click="chooseSalary(item)">
									{{item.label}}
									<i v-if="salary_min==item.min&&salary_max==item.max" class="el-icon-check icon"></i>
								</div>
							</div>
						</div>
					</div>
					<!-- 工作经验 -->
					<div class="tagbox">
						工作经验<span v-if="tag_name_year.length>0">（{{tag_name_year.length}}）</span>
						<div class="relativebox">
							<div class="screenlist" style="height: auto;width: 150px;">
								<div class="list" :class="{'select':tag_name_year.length==0}" @click="restScreen('tag_name_year','array')">
									不限
									<i v-if="tag_name_year.length==0" class="el-icon-check icon"></i>
								</div>
								<div 
									class="list" 
									:class="{'select':tag_name_year.includes(item)}"
									v-for="(item,index) in expList" 
									:key="index" 
									@click="chooseScreen(item,'tag_name_year')">
									{{item}}
									<i v-if="tag_name_year.includes(item)" class="el-icon-check icon"></i>
								</div>
							</div>
						</div>
					</div>
					<!-- 学历要求 -->
					<div class="tagbox">
						学历要求<span v-if="tag_name_qualifications.length>0">（{{tag_name_qualifications.length}}）</span>
						<div class="relativebox">
							<div class="screenlist" style="height: auto;width: 150px;">
								<div class="list" :class="{'select':tag_name_qualifications.length==0}" @click="restScreen('tag_name_qualifications','array')">
									不限
									<i v-if="tag_name_qualifications.length==0" class="el-icon-check icon"></i>
								</div>
								<div 
									class="list" 
									:class="{'select':tag_name_qualifications.includes(item)}"
									v-for="(item,index) in eduList" 
									:key="index" 
									@click="chooseScreen(item,'tag_name_qualifications')">
									{{item}}
									<i v-if="tag_name_qualifications.includes(item)" class="el-icon-check icon"></i>
								</div>
							</div>
						</div>
					</div>
					<!-- 公司规模 -->
					<div class="tagbox">
						公司规模<span v-if="company_sizes.length>0">（{{company_sizes.length}}）</span>
						<div class="relativebox">
							<div class="screenlist" style="height: auto;width: 150px;">
								<div class="list" :class="{'select':company_sizes.length==0}" @click="restScreen('company_sizes','array')">
									不限
									<i v-if="company_sizes.length==0" class="el-icon-check icon"></i>
								</div>
								<div 
									class="list" 
									:class="{'select':company_sizes.includes(item)}"
									v-for="(item,index) in scaleList" 
									:key="index" 
									@click="chooseScreen(item,'company_sizes')">
									{{item}}
									<i v-if="company_sizes.includes(item)" class="el-icon-check icon"></i>
								</div>
							</div>
						</div>
					</div>
					<div class="restbtn"><span @click="restSearch()">清空所有筛选项</span></div>
				</div>
			</div>

			<div class="container">
				<div class="corUl" v-loading="loading">
					<div class="nodata" v-if="list.length==0">
						<no-Data text="未检索到相关职位"></no-Data>
					</div>
					<div v-for="(item,index) of list" :key="index" class="corli" @click="postionDe(item.id)">
						<div class="top">
							<div class="info">
								<img v-if="item.top==1" src='@/static/pinnedIcon.png' class="icon" />
								<img v-if="item.is_selected==1" src='@/static/winnowIcon.png' class="icon" />
								<img v-if="item.type==2" src='@/static/jobIcon.png' class="icon" />
								<div class="title">
									{{item.position_name}}
								</div>

							</div>
							<div class="label">
								<div class="pay" v-if="item.type=='2'">{{item.salary_part_time_job}}</div>
								<div class="pay" v-else>
									{{`${parseFloat((item.salary_min/1000).toFixed(1))}-${parseFloat((item.salary_max/1000).toFixed(1))}k`}}
								</div>
								<!-- <div class="li">
									{{item.address.split('-')[1]}}
								</div> -->
								<template v-if="item.tag_name_others">
									<div v-for="(tag,i) in item.tag_name_others.split(',').slice(0,3)" :key="i" class="li">
										{{tag}}
									</div>
								</template>
								<!-- <div v-if="item.tag_name_others!=null" class="li">
									{{item.tag_name_others.split(',')[0]}}
								</div> -->
								<!-- <div class="li">
									{{item.tag_name_qualifications}}
								</div> -->
							</div>
						</div>
						<div v-if="item.company" class="bottom">
							<el-image :src="item.company.logo||require('@/static/company.png')" fit="cover" class="logo"></el-image>
							<div class="bottomRi">
								<div class="name">
									<span>{{item.company.company_name}}</span> {{item.company.person_count}}
								</div>
								<div class="address">
									<span>{{item.company.company_address}}{{item.company.address_detail?item.company.address_detail:''}}</span>
								</div>
							</div>
						</div>
					</div>
					<div v-if="total>limit" class="page">
						<el-pagination background :page-size="limit" :current-page="page" :page-sizes="[5, 10, 20]" layout="sizes,prev, pager, next" :total="total"
							@current-change='changePage' @size-change="changeLimit">
						</el-pagination>
					</div>
				</div>
				<downCode></downCode>
			</div>
		
			<el-dialog
				title="选择城市"
				:visible.sync="cityShow"
				width="640"
				lock-scroll
				append-to-body>
				<div class="chooseCitybox">
					<div class="headbox">
						<div class="text" :class="{'select':chooseCity=='ABCDE'}" @click="chooseCity='ABCDE'">ABCDE</div>
						<div class="text" :class="{'select':chooseCity=='FGHJ'}" @click="chooseCity='FGHJ'">FGHJ</div>
						<div class="text" :class="{'select':chooseCity=='KLMN'}" @click="chooseCity='KLMN'">KLMN</div>
						<div class="text" :class="{'select':chooseCity=='PQRST'}" @click="chooseCity='PQRST'">PQRST</div>
						<div class="text" :class="{'select':chooseCity=='WXYZ'}" @click="chooseCity='WXYZ'">WXYZ</div>
					</div>
					<div class="listbox">
						<div class="list" v-for="(first,index) in chooseCity" :key="index">
							<div class="left">{{first}}</div>
							<div class="right">
								<div class="text" v-for="(item,i) in cityList[first]" :key="i">
									<span :class="{'select':city==item.name}" @click="changeCity(item.name)">{{item.name}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-dialog>
		</div>

	</div>
</template>

<script>
	import { eduList, expList, scaleList } from '@/unit/disposition.js';
	import downCode from '@/components/downCode.vue'
	export default {
		components: { downCode, },
		data() {
			return {
				position_name: '',
				page: 1,
				total: 0,
				loading: false,
				list: [],
				limit: 5,
				id:'',
				cityShow: false, //弹出框的状态
				city:'',
				cityList:{},
				chooseCity:'ABCDE',
				positionTypeList:[],
				position_type_ids:[],
				type:'',
				expList:expList,
				tag_name_year:[],
				eduList:eduList,
				tag_name_qualifications:[],
				scaleList:scaleList,
				company_sizes:[],
				salary_min:'',
				salary_max:'',
				salaryList:[
					{min:0,max:0,label:'不限'},
					{min:0,max:3000,label:'3k以下'},
					{min:3000,max:5000,label:'3-5k'},
					{min:5000,max:10000,label:'5-10k'},
					{min:10000,max:20000,label:'10-20k'},
					{min:20000,max:50000,label:'20-50k'},
					{min:50000,max:0,label:'50k以上'},
				],
				jobIndex:-1,
			}
		},
		created() {
			this.getpositionType()
			this.getCityList()
		},
		async mounted() {
			if (this.$route.params.name) {
				this.position_name=this.$route.params.name
			}
			if (this.$route.params.id) {
				this.position_type_ids.push(this.$route.params.id)
			}
			this.city = await this.$util.getIpCity()
			this.getList()
		},
		methods: {
			changeCity(city){
				if(this.city==city) return;
				this.city = city
				this.cityShow = false
				this.search()
			},
			getCityList(){
				this.$axios.get('/api/client/Common/getAreaSeparate',{params:{level:2}}).then(res=>{
					if(res.code==200){
						res.data.forEach(e => {
							if(!this.cityList.hasOwnProperty(e.first)) this.cityList[e.first] = [];
							this.cityList[e.first].push(e)
						});
					}else{
						this.$eltips(res.msg,'error')
					}
				})
			},
			restSearch(){
				this.type = ''
				this.salary_min = 0
				this.salary_max = 0
				this.position_type_ids = []
				this.tag_name_year = []
				this.tag_name_qualifications = []
				this.company_sizes = []
				this.search()
			},
			pickType(e){
				this.type = e
				this.search()
			},
			restScreen(params,type){
				if(type=='array'){
					this[params] = []
				}else{
					this[params] = ''
				}
				this.search()
			},
			chooseJobType(id){
				if(this.position_type_ids.includes(id)){
					const index = this.position_type_ids.findIndex(e=>e==id)
					this.position_type_ids.splice(index,1)
				}else{
					this.position_type_ids.push(id)
				}
				this.search()
			},
			calcChild(child){
				let count = 0
				for(let i=0;i<child.length;i++){
					if(this.position_type_ids.includes(child[i].id)) count++;
				}
				return count
			},
			chooseSalary(item){
				this.salary_min = item.min
				this.salary_max = item.max
				this.search()
			},
			chooseScreen(val,params){
				if(this[params].includes(val)){
					let index = this[params].findIndex(e=>e==val)
					this[params].splice(index,1)
				}else{
					this[params].push(val)
				}
				this.search()
			},
			getpositionType(){
				this.$axios.get('/api/client/Common/getPositionType').then(res=>{
					if(res.code==200){
						this.positionTypeList = res.data
					}else{
						this.$eltips(res.msg,'error')
					}
				})
			},
			// 搜索
			search() {
				this.page = 1
				this.getList()
			},
			getList() {
				this.loading = true
				let data = {
					page: this.page,
					position_name: this.position_name,
					limit: this.limit,
					city:this.city,
					type:this.type,
					salary_min:this.salary_min,
					salary_max:this.salary_max,
					position_type_ids:this.position_type_ids.join(','),
					tag_name_year:this.tag_name_year.join(','),
					tag_name_qualifications:this.tag_name_qualifications.join(','),
					company_sizes:this.company_sizes.join(','),
				}

				this.$axios.get('/api/client/Home/getPosition', {
					params: data
				}).then(res => {
					this.loading = false
					if (res.code == 200) {
						this.total = res.data.total
						this.list = res.data.data
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			changeLimit(e){
				this.limit = e
				this.changePage(1)
			},
			changePage(e) {
				this.page = e
				this.getList()
			},
			postionDe(id){
				this.$router.push({ name: 'positionDe', query: { id: id } });
			}
		}
	}
</script>

<style lang="scss" scoped>
	.searchCon {
		position: relative;
		padding: 18px 0 28px;
		width: 100%;
		box-sizing: border-box;
		// min-height: 800px;
	}

	::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #51A190;
	}
	::-webkit-scrollbar {
		width: 4px;
		/*  设置纵轴（y轴）轴滚动条 */
		height: 8px;
		/*  设置横轴（x轴）轴滚动条 */
	}
	/* 滚动条滑块（里面小方块） */
	::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background: rgba(66, 66, 66, 0.1);
	}
	/* 滚动条轨道 */
	::-webkit-scrollbar-track {
		background: rgba(0, 0, 0, 0.1);
		border-radius: 10px;
		margin: 8px 0;
	}

	.content {
		position: relative;
		z-index: 2;
	}
	.topHead{
		width: 1200px;
		margin: 0 auto;
		background: #FFF;
		border-radius: 8px;
		margin-bottom: 18px;
		padding: 18px 26px;
		box-sizing: border-box;
		.searchbox{
			border: 2px solid #51A190;
			border-radius: 8px;
			display: flex;
			align-items: center;
			.city{
				font-size: 16px;
				padding: 0 18px;
				width: 100px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				position: relative;
				cursor: pointer;
				line-height: 1;
				margin-right: 14px;
				&::after{
					content: '';
					width: 0;
					height: 0;
					position: absolute;
					right: 0;
					top: 50%;
					margin-top: -3px;
					border-top: 6px solid #ccc;
					border-right: 6px solid transparent;
					border-left: 6px solid transparent;
				}
				
				&:hover{
					color: #51A190;
					&::after{
						border-top-color: #51A190;
					}
				}
			}
			.input{
				flex: 1;
				height: 50px;
				line-height: 50px;
				font-size: 16px;
				box-sizing: border-box;
			}
			.btnsty{
				width: 120px;
				text-align: center;
				line-height: 50px;
				background: #51A190;
				font-size: 20px;
				color: #fff;
				cursor: pointer;
			}
		}
		.screenbox{
			margin-top: 12px;
			.tagbox{
				display: inline-block;
				cursor: pointer;
				padding: 8px 30px 8px 12px;
				background: #f3f3f3;
				font-size: 14px;
				line-height: 1;
				position: relative;
				margin-right: 18px;
				&::after{
					content: '';
					width: 0;
					height: 0;
					position: absolute;
					right: 12px;
					top: 50%;
					margin-top: -2px;
					border-top: 5px solid #999;
					border-right: 5px solid transparent;
					border-left: 5px solid transparent;
				}
				&:hover{
					color: #51A190;
					&::after{
						border-top: none;
						border-left: 5px solid transparent;
						border-right: 5px solid transparent;
						border-bottom: 5px solid #51A190;
					}
					.screenlist{
						display: block;
					}
				}
				.relativebox{
					position: relative;
				}
				.screenlist{
					display: none;
					overflow-y: auto;
					overflow-x: visible;
					position: absolute;
					z-index: 9;
					left: -12px;
					top: 8px;
					background: #FFF;
					color: #131313;
					padding: 8px;
					width: 226px;
					height: 320px;
					box-sizing: border-box;
					box-shadow: 2px 2px 1px 0px rgba(0, 0, 0, 0.1);
					.list{
						padding: 14px 24px 14px 12px;
						overflow-y: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						-webkit-touch-callout: none;
						-webkit-user-select: none;
						-moz-user-select: none; 
						-ms-user-select: none;
						user-select: none;  
						&:hover{
							color: #51A190;
							background: #F8F8F8;
						}
					}
					.select{
						color: #51A190 !important;
						position: relative;
						.icon{
							font-size: 16px;
							position: absolute;
							top: 50%;
							right: 0;
							margin-top: -8px;
						}
					}
				}
				.listChild{
					width: 600px;
					height: 322px;
					padding: 12px;
					background: #FFFFFF;
					position: absolute;
					top: 8px;
					left: 214px;
					z-index: 10;
					border-radius: 8px;
					box-sizing: border-box;
					border: 1px solid #e3e3e3;
					.chiildTitle{
						line-height: 1;
						padding-bottom: 12px;
						font-size: 16px;
						box-sizing: border-box;
						border-bottom: 1px solid #e3e3e3;
						color: #151515;
					}
					.childContent{
						height: 228px;
						overflow-y: auto;
						.text{
							display: inline-block;
							color: #151515;
							width: 132px;
							margin-right: 14px;
							margin-top: 18px;
							overflow: hidden;
							text-overflow: ellipsis;
							vertical-align: top;
							-webkit-touch-callout: none;
							-webkit-user-select: none;
							-moz-user-select: none; 
							-ms-user-select: none;
							user-select: none;  
							&:nth-child(4n){
								margin-right: 0;
							}
							span{
								&:hover{
									color: #51A190;
								}
							}
						}
						.select{
							color: #51A190;
							font-weight: bold;
						}
					}
				}
			}
			.restbtn{
				float: right;
				line-height: 1;
				font-size: 14px;
				padding: 8px 0;
				color: #999;
				span{
					cursor: pointer;
				}
			}
		}
	}
	.container {
		width: 1200px;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		margin: 0 auto;
		.corUl {
			flex: 1;
			margin-right: 14px;
			min-height: 200px;
			.nodata{
				height: 400px;
				background: #FFF;
			}
			.corli {
				display: flex;
				align-items: center;
				background-color: #FFF;
				padding: 18px 26px;
				margin-bottom: 16px;
				border-radius: 8px;
				cursor: pointer;
				.top {
					flex: 1;
					.info {
						display: flex;
						align-items: center;
						margin-bottom: 15px;
						.icon{
							width: 43px;
							height: 20px;
							margin-right: 10px;
						}
						.title {
							color: #151515;
							font-size: 18px;
							width: 260px;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							font-weight: bold;
						}
	
					}
	
					.label {
						display: flex;
						align-items: center;
						.pay {
							color: #51A190;
							font-size: 16px;
							margin-right: 18px;
						}
	
						.li {
							padding: 3px 14px;
							background-color: #F5F5F5;
							border-radius: 2px;
							color: #5E5E5E;
							font-size: 13px;
							display: block;
							margin-right: 8px;
							max-width: 80px;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
	
							&:last-child {
								margin-right: 0;
							}
						}
					}
				}
	
				.bottom {
					color: #151515;
					font-size: 14px;
					display: flex;
					align-items: center;
					flex: 1;
	
					.logo {
						margin-right: 12px;
						border-radius: 2px;
						width: 64px;
						height: 64px;
						flex: 0 0 64px;
					}
	
					.bottomRi {
						height: 64px;
						display: flex;
						// align-items: center;
						flex-direction: column;
						justify-content: space-around;
						.name {
							span {
								display: inline-block;
								vertical-align: middle;
								font-weight: bold;
								margin-right: 12px;
								font-size: 18px;
								max-width: 280px;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
							}
						}
						.address{
							span{
								display: inline-block;
								width: 360px;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
							}
						}
					}
				}
			}
		}
	}
	.page {
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 28px 0 0;
	}
	
	.chooseCitybox{
		.headbox{
			background: #F8F8F8;
			padding: 18px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.text{
				cursor: pointer;
				&:hover{
					color: #51A190;
				}
			}
			.select{
				font-weight: bold;
				color: #51A190;
			}
		}
		.listbox{
			margin-top: 18px;
			padding:0 18px;
			max-height: 380px;
			overflow-y: scroll;
			.list{
				display: flex;
				.left{
					margin-right: 48px;
				}
				.right{
					flex: 1;
					display: flex;
					flex-wrap: wrap;
					.text{
						width: 20%;
						margin-bottom: 28px;
						line-height: 1;
						span{
							width: 100%;
							display: inline-block;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							cursor: pointer;
						}
						.select{
							color: #51A190;
						}
					}
				}
			}
		}
	}
</style>